<div
  class="rounded-lg bg-gray-200 font-bold text-brand-secondary px-2 py-3 text-xs"
>
  <ng-content></ng-content>
</div>
